module.exports = __webpack_public_path__ + "static/img/产品界面图_07@2x.db04527b.png";